export const CurrencySymbol = "₹";

//sandbox testing environment
// export const ReactProjectBaseUrl = "https://bharatbiz.app:8443";
// export const ReactProjectBaseUrl = "http://192.168.149.83:8443";

//pre prod environment
// export const ReactProjectBaseUrl = "https://croods.vasy.app:8443";

//prod environment
export const ReactProjectBaseUrl = "https://vasy.in:8443"; //Prod URL.

// export const ReactProjectBaseUrl = "https://croods.vasy.app:8443";

export const FETCH_CATEGORIES_LIST_LIMIT = 100;
export const FETCH_BRAND_LIST_LIMIT = 10;
export const TOASTER_MESSAGES = {
  ADD_TO_CART_MESSAGE: "Added into Cart...!!!",
  REMOVE_FROM_CART_MESSAGE: "Removed from Cart...!!!",
  VALID_MOBILE_NO_MESSAGE: "Invalid Mobile Number!",
  WRONG_OTP_MESSAGE: "OTP is Wrong...!!!",
  VALID_OTP_MESSAGE: "OTP verified Succesfully.!",
  SOMETHING_WENT_WRONG_MESSAGE: "Something Went Wroong...!!!",
  ENTER_MOBILE_NO: "Please Enter Mobile No",
  SPECIFY_LOCATION_TO_PROCEED_FURTHER: "Specify location to proceed further.!",
  OTP_NOT_MATCHED_TOASTER: "Sorry Your OTP is not match.!",
  ENTER_OTP_TOASTER: "Please Enter OTP.!",
  SUCCESSFULLY_SIGN_UP_TOASTER: "You have successfully signed up.!",
  SOMETHING_WENT_WRONG_IN_SIGNUP_TOASTER: "Something Went Wrong In SignUp.!",
  INVALID_EMAIL_TOASTER: "Please enter valid Email ID.!",
  REQUIRED_NAME_TOASTER: "Please enter profile name.!",
  ADD_TO_WISHLIST_MESSAGE: "Added into Wishlist...!!!",
  REMOVE_FROM_WISHLIST_MESSAGE: "Removed from Wishlist...!!!",
  ADD_TO_WISHLIST_ERROR_MESSAGE: "Please Login ",
};

export const CATEGORY_IMAGE_PREFIX =
  "https://ik.imagekit.io/6gua1wejtw0/1385/category/";
export const GOOGLE_API_KEY = "AIzaSyC-_2Xo2qDxgAGnkFjAHHLp1u116M27HA4";

export const MIN_PRICE_VALUE = 0;
export const MAX_PRICE_VALUE = 5000;
export const IMAGEKIT_PREFIX = "https://ik.imagekit.io/6gua1wejtw0";
export const RAZORPAY_KEY_ID = "rzp_test_sNg00pqlkHH3JF";
export const RAZORPAY_KEY_SECRET = "v5iOnDSHLOPOfJbNXzTYApu3";

// ORDER ONLINE STATUS
export const ONLINE_ORDER_STATUS = {
  ONLINE_ORDER_PENDING: "pending",
  ONLINE_ORDER_CONFIRMED: "Order confirmed",
  ONLINE_INPROGRESS: "In progress",
  ONLINE_OUTFORDELIVERY: "Out for delivery",
  ONLINE_DELIVERED: "Delivered",
  ONLINE_CANCELLED: "Cancelled",
  ONLINE_RETURNCANCELLED: "Return",
};

export const RELATEABLE_DIV_SHOW_ON_QUICKVIEW = {
  ADD_PRODUCT_VARIANTS: "addProductVariants",
  REMOVEPRODUCT_VARIANTS: "removeProductVariants",
  REPEAT_LAST_VARINATS: "repeateLastVariants",
};

export const ALGOLIA_APP_ID = "7N4FJW5ZC2";
export const ALGOLIA_APP_KEY = "d273bdd1271acc3ef17b5907916c67b0";
export const TYPESENSE_CREDENTIALS = {
  apiKey: "uSKtoxnEFg37SI1YMApsloAo2T0tNpoRHsgRiua1OOZAegYS",
  host: "typesense.vasyerp.com",
  port: "443",
  protocol: "https",
};
export const ADD_TO_CART_LIMIT = 15;

export const ADD_TO_CART_ICON = (
  <svg
    className="pb-1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 381.2 381.6"
    style={{ width: "15px", marginRight: "5px" }}
    xmlSpace="preserve"
  >
    <path d="M188.3 193.2" />
    <path d="M339.9 133.3H323c-2.8 0-5.1 0-7.3.1h-.3c-5 0-8.1-2.9-8.4-8-.4-5.2-.8-10.4-1.6-15.4-3.4-20.1-9.9-37.9-19.2-53-9.7-15.9-22.9-29.4-39.2-40-17.3-11.3-35.9-17-55.3-17-7.9 0-16 1-24.1 2.9-15.6 3.6-29.8 10.3-42.1 19.9-11.7 9.1-22.1 21-30.9 35.4-12.2 20-19.1 42.5-20.3 66.7-.3 5.5-3.4 8.5-8.8 8.5h-.3c-3.7-.1-7.5-.1-11.5-.1-4.8 0-9.8 0-15.1.1-8.4.2-15.8 3.2-21.9 9-14.8 14-19.6 31.4-14.7 53.4 6.4 28.3 13.8 61.3 21.2 93.7 1.2 5.1 2.3 10.3 3.4 15.3 3.4 15.6 7 31.7 11.4 47.2 5.1 17.9 20.5 29.5 39.2 29.5h.5c13.5-.1 28.1-.2 45.9-.2H304.2c9 0 16.5-2.3 22.9-6.9 9.3-6.8 15.4-16.6 18.4-29.9 7.9-34.7 15.8-69.5 23.7-104.2l10.3-45.1c3.5-15.5 1.8-29-5.2-41.2-8.3-13.9-19.5-20.7-34.4-20.7zm-243.5-6c.2-1.9.5-3.9.7-5.8.5-4.2.9-8.5 1.8-12.8 5.7-27.3 18.3-49.3 37.5-65.6 15.5-13.1 34.8-20.3 54.3-20.3 21.9 0 42.9 8.8 59.1 24.8 20.9 20.6 32.5 47 34.6 78.4.1.8-.1 1.5-.1 1.9 0 .1-.1.3-.1.5-.3 2.5-2.4 4.4-5 4.4H101.3c-1.4 0-2.8-.6-3.8-1.7-.9-1-1.3-2.4-1.1-3.8zm262.2 55.1c-4.3 20.5-8.2 38.3-11.8 54.6-8.4 37.5-15.9 70.4-22.9 100.7-1 4.2-2.6 8.4-4.8 12.6-2 3.9-6.2 8.5-14.8 8.5h-.1c-21.9-.1-43.6-.1-60.1-.1H78.8c-10.7 0-16.7-4.4-19.5-14.2-2.7-9.9-5-20-7.2-29.7l-1.2-5.4c-8.1-35.6-16.6-73.2-26.8-118.2-1.6-7.3-2.8-15.1-.3-23.1 2.5-8 7.4-11.8 15.8-12.3.7 0 1.4-.1 2.3-.1h297.4c12.2 0 18.1 5.2 19.6 17.4.3 3.5.3 6.6-.3 9.3z" />
    <path d="M267.4 198.2c-5.4 0-11.1 4.5-11.1 12.1-.1 20.7-.1 41.7 0 62v28.6c0 3.5-.1 7.1.1 10.6.2 6.2 4.8 10.8 10.9 11h.3c6.7 0 11.3-5 11.3-12.4.1-11.6.1-23.3 0-34.7V211.1c0-5.4-1.8-8.9-5.6-11.2-1.9-1.1-3.8-1.7-5.9-1.7zM120.9 260.3v-12.4c0-12 0-24.4-.1-36.6 0-2.5-.4-4.8-1.2-6.6-1.6-3.8-5.7-6.4-9.9-6.4-.6 0-1.3.1-1.9.2-5.7 1.1-9.1 5.2-9.5 11.4-.2 4-.2 8.2-.1 12.2v87.4c0 6.4 2.1 10.2 6.8 12.3 1.5.7 3.1 1 4.6 1 5.4 0 11-4.3 11.1-11.4.1-11.9.1-24 .1-35.7.1-5.2.1-10.3.1-15.4zM188.3 198.2c-6.2 0-10.9 5.2-11 12.2-.1 9.5-.1 19.3-.1 28.7v70.7c0 8 4.1 10.7 7.1 12 1.5.6 2.9.9 4.4.9 6.1 0 11-5.2 11.1-11.8.1-11.6.1-23.5.1-34.9v-65.5c0-5.6-2.3-9.1-7.1-11.2-1.4-.7-3-1.1-4.5-1.1z" />
    <path
      style={{
        fill: "#fff",
      }}
      d="M188.3 193.2"
    />
  </svg>
);

export const CHECKOUT_ICON = (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 383.1 343.1"
    style={{
      enableBackground: "new 0 0 383.1 343.1",
      width: "20px",
      fill: "var(--white)",
    }}
    xmlSpace="preserve"
  >
    <style>{".st0"}</style>
    <path d="M0 8.6C2.7 2.1 7.6-.2 14.5 0c12.5.3 25 .1 37.4.1 15.2.1 24.8 7.5 28.8 22.2 3.9 14.6 7.9 29.1 11.7 43.8.7 2.7 1.7 3.6 4.5 3.6 54.9.1 109.8.4 164.7.6 32.7.1 65.4.3 98 .5 16 .1 26.4 12.7 22.9 28.3-8.9 39.4-18 78.8-27.2 118.2-3.1 13-13.8 21.1-27.3 21.4-4.7.1-9.5 0-14.2 0-66.4 0-132.7-.1-199.1-.1-1.7 0-3.5 0-5.2.2-6.5.7-11.1 5.9-11.1 12.5s4.6 11.7 11.2 12.4c1.7.2 3.5.1 5.2.1h219.3c8.9 0 14.2 5.1 13.3 12.8-.5 4.4-3.2 7.1-7 9.1 7.4 20.4 3.8 37.8-14.4 50.5-13.2 9.2-31.3 8.4-44.2-1.1-14.8-10.9-19-26-13-48.5h-69.9c7 20 3.2 37.2-14.6 49.4-13.9 9.5-29.1 9.4-42.9 0-17.7-12.1-21.4-29.3-14.5-49.7-5.4 0-10.4.1-15.5 0-18.4-.3-32.5-12.4-35.3-30.1-3-19.1 11.1-37.6 30.3-39.8.9-.1 1.7-.2 2.8-.4-.3-1.5-.5-2.8-.9-4.1C92 150.7 75.5 89.5 59 28.3c-1.3-5-2.2-5.6-7.2-5.6-12.5 0-25-.2-37.4.1-6.9.1-11.9-2.3-14.4-8.9V8.6zm99.5 83.7c4.5 16.7 8.8 32.6 13 48.7.6 2.2 1.8 2.5 3.8 2.5 12.5-.1 24.9 0 37.4 0 .9 0 1.9-.2 3-.4-.2-1.8-.2-3.2-.4-4.7-1.9-14.2-3.9-28.4-5.7-42.6-.3-2.6-1.2-3.3-3.7-3.3-10 .1-19.9-.1-29.9-.1-5.7-.1-11.4-.1-17.5-.1zm145.6.7v50.1c.6.2.9.3 1.3.3 13 0 25.9 0 38.9.1 2.2 0 2.7-1.1 2.9-2.9 1.4-11.3 3-22.5 4.4-33.8.6-4.5 1.1-9 1.7-13.8h-49.2zm-72.3-.3c2.3 17.1 4.5 33.8 6.7 50.5H222V92.7h-49.2zm188.1.4h-41.7c-2.4 0-2.4 1.6-2.6 3.2-1.6 12.5-3.3 25-5 37.5-.4 3.1-.7 6.2-1 9.6 12.6 0 24.6 0 36.5-.1.9 0 2.3-1.3 2.6-2.2 3.7-15.7 7.4-31.5 11.2-48zm-241.6 72.8c4.3 15.9 8.3 31.1 12.7 46.3.5 1.6 3 3.6 4.6 3.6 9.8.3 19.6.2 29.5.2 0-.9.2-1.5.1-2.1-2-15.3-4-30.7-6.1-46-.1-.8-1.5-2-2.3-2h-38.5zM245 216.2c10.6 0 20.8.1 31-.1.8 0 2.2-1.7 2.3-2.8 1.3-8.9 2.5-17.8 3.7-26.7.9-6.8 1.7-13.5 2.6-20.5H245v50.1zm-62.4-50.1c2.1 16.2 4.2 31.9 6.2 47.6.3 2.1 1.2 2.6 3.2 2.6 8.5-.1 16.9 0 25.4 0h4.7v-50.1c-13.2-.1-26.2-.1-39.5-.1zm118.2 50.1h25.7c4.7 0 6.3-1.4 7.4-6.2 1.7-7.3 3.4-14.6 5.1-21.8 1.7-7.2 3.3-14.5 5-22.1h-36.6c-2.2 16.6-4.4 33.1-6.6 50.1zM162.8 320c9.3-.1 16.9-7.7 16.7-17-.1-9.1-7.7-16.6-16.8-16.7-9.2-.1-16.8 7.6-16.8 17s7.5 16.8 16.9 16.7zm141.8 0c9.4 0 16.9-7.4 16.9-16.8 0-9.3-7.7-17-16.9-16.9-9.1.1-16.6 7.5-16.7 16.7-.2 9.4 7.3 17 16.7 17z" />
    <path
      className="st0"
      d="M99.5 92.3H117c10 0 19.9.2 29.9.1 2.5 0 3.3.7 3.7 3.3 1.8 14.2 3.8 28.4 5.7 42.6.2 1.5.3 2.9.4 4.7-1.2.1-2.1.4-3 .4h-37.4c-2 0-3.2-.3-3.8-2.5-4.2-16-8.5-32-13-48.6zM245.1 93h49.1c-.6 4.8-1.1 9.3-1.7 13.8-1.5 11.3-3 22.5-4.4 33.8-.2 1.8-.7 2.9-2.9 2.9-13-.1-25.9-.1-38.9-.1-.3 0-.7-.2-1.3-.3.1-16.7.1-33.3.1-50.1zM172.8 92.7h49.3v50.5h-42.5c-2.3-16.7-4.5-33.4-6.8-50.5zM360.9 93.1c-3.8 16.5-7.4 32.2-11.2 48-.2.9-1.7 2.2-2.6 2.2-12 .1-23.9.1-36.5.1.4-3.4.6-6.5 1-9.6 1.6-12.5 3.3-25 5-37.5.2-1.7.1-3.2 2.6-3.2h41.7zM119.3 165.9c13.4 0 25.9 0 38.5.1.8 0 2.2 1.2 2.3 2 2.1 15.3 4.1 30.6 6.1 46 .1.6 0 1.2-.1 2.1-9.9 0-19.7.2-29.5-.2-1.6-.1-4.2-2.1-4.6-3.6-4.4-15.2-8.4-30.5-12.7-46.4zM245 216.2v-50h39.6c-.9 7-1.7 13.7-2.6 20.5-1.2 8.9-2.3 17.8-3.7 26.7-.2 1.1-1.5 2.7-2.3 2.8-10.1.1-20.3 0-31 0zM182.6 166.1h39.5v50.1h-4.7c-8.5 0-16.9-.1-25.4 0-2 0-2.9-.5-3.2-2.6-2-15.6-4.1-31.3-6.2-47.5zM300.8 216.2c2.2-17 4.4-33.5 6.6-50.1H344c-1.7 7.5-3.3 14.8-5 22.1-1.7 7.3-3.4 14.6-5.1 21.8-1.1 4.8-2.7 6.1-7.4 6.2h-25.7zM162.8 320c-9.4.1-16.9-7.3-16.9-16.8 0-9.4 7.6-17 16.8-17 9.1.1 16.7 7.6 16.8 16.7.2 9.4-7.4 17.1-16.7 17.1zM304.6 320c-9.4 0-16.8-7.6-16.7-17 .1-9.2 7.6-16.7 16.7-16.7 9.2-.1 16.9 7.6 16.9 16.9 0 9.4-7.5 16.9-16.9 16.8z"
    />
  </svg>
);

export const REMOVE_ITEMS_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{
      enableBackground: "new 0 0 24 24",
      width: "20px",
      height: "20px",
    }}
    xmlSpace="preserve"
  >
    <path
      className="st0"
      d="M21.7 4.4h-2.9c-.2 0-.3 0-.3-.3v-.8c0-1.8-1.4-3.2-3.2-3.2H8.6C7 .1 5.7 1.3 5.5 2.8c-.1.5-.1 1 0 1.4 0 .2 0 .2-.2.2H2.1c-.5 0-.9.5-.9 1-.1.5.3 1 .8 1.1.4 0 .4.2.4.5v.2l.3 4.5c0 2 .2 4.2.3 6.3 0 .6.1 1.1.2 1.7C3.7 22.2 6 24 8.6 24h7c1.7 0 3.3-.8 4.3-2.2.7-1 1.1-2.3 1.1-3.6 0-1.2.1-2.5.2-3.7.1-1.3.2-2.6.2-3.8.1-1.3.2-2.5.2-3.8 0-.2.1-.3.3-.3.5-.1.8-.4.9-.9.2-.6-.2-1.2-.8-1.3h-.3m-14-.2v-.8c0-.6.4-1.1 1-1.1h6.5c.6 0 1.1.5 1.1 1.1v.8c0 .2-.1.2-.2.2H7.9c-.2 0-.3 0-.2-.2m11.8 2.6c-.1 1.2-.2 2.5-.2 3.7-.1 1.3-.2 2.5-.2 3.8-.1 1.2-.1 2.4-.2 3.7 0 .7-.1 1.4-.4 2.1-.5 1.1-1.6 1.7-2.8 1.7H8.5c-1.7 0-3.1-1.4-3.2-3.2L5 14.1c-.1-1.2-.1-2.4-.2-3.6-.2-1.2-.2-2.5-.3-3.7 0-.2 0-.2.2-.2h14.6c.2 0 .2 0 .2.2"
    />
    <path
      className="st0"
      d="M9.8 9.8c-.6 0-1.1.5-1.1 1.1v6.4c0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1v-6.4c0-.6-.4-1.1-1.1-1.1M15.3 10.9c0-.6-.5-1.1-1.1-1.1-.6 0-1.1.5-1.1 1.1v6.5c0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1v-6.5"
    />
  </svg>
);

export const defaultCategorySvg = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"

	 viewBox="0 0 56.6 65.1" style="enable-background:new 0 0 56.6 65.1;" xml:space="preserve">

<g id="Group_651" class="st0">

	<g>

		<defs>

			<rect id="SVGID_1_" width="56.6" height="65.1"/>

		</defs>

		<clipPath id="SVGID_00000129181994990600950780000015323913370985083779_">

			<use xlink:href="#SVGID_1_"  style="overflow:visible;"/>

		</clipPath>

		<g id="Group_650" style="clip-path:url(#SVGID_00000129181994990600950780000015323913370985083779_);">

			<path id="Path_1122" class="st2" d="M1.3,23.7l6.9,0l0.7,2.5L2.5,26c-0.6,0-1.1-0.5-1.1-1.1L1.3,23.7z"/>

			<path id="Path_1123" class="st3" d="M28.7,20.5l3.9,13.7c0.1,0.4-0.1,0.9-0.6,1c0,0,0,0,0,0l-18.3,5.1c-0.4,0.1-0.9-0.1-1-0.6

				c0,0,0,0,0,0L8.8,26.1L2.5,26c-0.6,0-1-0.4-1.1-1l-0.8-6.8c-0.1-1.1,0.3-2.2,1.2-2.9l6.9-5.2l12.1-3.4l4.8,0.5l2.3,0.2l1.5,0.2

				c1.1,0.1,2.1,0.8,2.5,1.8l2.9,6.2c0.2,0.5,0,1.1-0.4,1.4L28.7,20.5z"/>

			<path id="Path_1124" class="st4" d="M26.1,16.8c-1,0.6-1.4,1.7-1.1,2.8l4.3,15.4c0.1,0.4-0.1,0.9-0.6,1c0,0,0,0,0,0l3.3-0.9

				c0.4-0.1,0.7-0.6,0.6-1L27.5,16L26.1,16.8z"/>

			<path id="Path_1125" class="st4" d="M34.8,15.6l-2.9-6.2c-0.5-1-1.4-1.7-2.5-1.8l-1.5-0.2l-2.3-0.2l-4.8-0.5l-3.3,0.9l4.8,0.5

				l2.3,0.2l1.5,0.2c1.1,0.1,2.1,0.8,2.5,1.8l2.9,6.2c0.2,0.5,0,1.1-0.4,1.4l-2.6,1.6l0.3,0.9l5.6-3.4C34.8,16.7,35,16.1,34.8,15.6"

				/>

			<path id="Path_1126" class="st2" d="M34.2,14.4L28.3,18l0.7,2.5l5.3-3.5c0.5-0.3,0.7-1,0.4-1.5L34.2,14.4z"/>

			<path id="Path_1127" class="st2" d="M32,35.2l-18.2,5.1c-0.5,0.1-0.9-0.1-1.1-0.6L12,37.4l19.9-5.6l0.6,2.3

				C32.7,34.6,32.5,35,32,35.2C32,35.2,32,35.2,32,35.2"/>

			<path id="Path_1128" class="st5" d="M15.6,11.9l3.3-6.6L9.3,8L15.6,11.9z"/>

			<path id="Path_1129" class="st2" d="M9.3,8l6.3,3.9l-1.6,1.8L8.4,9.9L9.3,8z"/>

			<path id="Path_1130" class="st2" d="M18.9,5.3l-3.3,6.6l2.3,0.6l2.8-6.2L18.9,5.3z"/>

			<path id="Path_1131" d="M9.4,30.1c0.1,0.3,0.4,0.5,0.7,0.4c0.3-0.1,0.5-0.4,0.4-0.7C10,28,8.4,22.2,7.9,20.4

				C7.8,20.1,7.5,20,7.2,20c-0.3,0.1-0.5,0.4-0.4,0.7c0,0,0,0,0,0l0.7,2.4l-5.6,0l-0.6-5c-0.1-0.9,0.3-1.8,1-2.4l6.5-5l4.9,3.4

				c0.2,0.2,0.6,0.1,0.8-0.1l0.9-1l1.7,6c0.1,0.3,0.4,0.5,0.7,0.4c0.3-0.1,0.5-0.4,0.4-0.7c0,0,0,0,0,0l-1.7-6l1.3,0.4

				c0.3,0.1,0.6-0.1,0.7-0.3l2.5-5.5c4.7,0.5,4.5,0.5,4.8,0.5C26,7.6,26.2,7.3,26.1,7c-0.1-0.2-0.3-0.4-0.5-0.4l-4.4-0.5

				C21.2,6,21.1,5.9,21,5.9c-1.9-1.2-1.8-1.1-1.8-1.1c-0.4-0.2-0.2,0-4.6,1.1l-0.2-0.6c1.4-0.7,1.9-2.4,1.2-3.8

				c-0.7-1.4-2.4-1.9-3.8-1.2c-1.2,0.6-1.8,2-1.4,3.3c0.1,0.3,0.4,0.5,0.7,0.4c0.3-0.1,0.5-0.4,0.4-0.7c0,0,0,0,0,0

				c-0.2-0.9,0.3-1.8,1.2-2.1c0.9-0.2,1.8,0.3,2.1,1.2c0.2,0.9-0.3,1.8-1.2,2.1c-0.3,0.1-0.5,0.4-0.4,0.7c0,0,0,0,0,0l0.3,1.1

				C9.1,7.5,9,7.4,8.8,7.7c-0.1,0.1,0,0-1,1.9c-0.1,0.1-0.1,0.3,0,0.4l-6.4,4.9c-1,0.8-1.6,2.1-1.4,3.4l0.8,6.8

				c0.1,0.8,0.8,1.5,1.7,1.5l5.9,0L9.4,30.1z M15.4,11.1l-2.6-1.6l1.6-2.2l2.4,1C16.3,9.3,15.6,10.5,15.4,11.1 M17.6,11.9l-1.2-0.3

				c0.6-1.2,2.2-4.3,2.7-5.4L20,6.6L17.6,11.9z M17.3,7.2l-1.2-0.5l1.7-0.5L17.3,7.2z M12.6,7.7l-0.9,1.2l-1-0.6L12.6,7.7z M9.5,8.8

				c1.3,0.8,4.3,2.7,5.2,3.2l-0.8,0.9L9.1,9.7L9.5,8.8z M2.5,25.4C2.3,25.4,2,25.2,2,25l-0.1-0.7l5.8,0l0.3,1.2L2.5,25.4z"/>

			<path id="Path_1132" d="M35.3,15.4l-2.9-6.2c-0.6-1.2-1.7-2-3-2.2l-1.5-0.2c-0.3,0-0.6,0.2-0.6,0.5c0,0.3,0.2,0.6,0.5,0.6

				l1.5,0.2c0.9,0.1,1.7,0.7,2.1,1.5l2.1,4.6l-5,3l-0.7-2.4c-0.1-0.3-0.4-0.5-0.7-0.4c-0.3,0.1-0.5,0.4-0.4,0.7l4.6,16.3l-18.8,5.3

				l-1.4-4.8c-0.1-0.3-0.4-0.5-0.7-0.4c-0.3,0.1-0.5,0.4-0.4,0.7l2.2,7.7c0.2,0.8,1,1.2,1.8,1l18.3-5.2c0.8-0.2,1.2-1,1-1.8

				l-3.7-13.2l5.2-3.2C35.4,17.1,35.6,16.2,35.3,15.4 M13.6,39.8c-0.2,0-0.3,0-0.4-0.2l-0.5-1.7l18.8-5.3l0.5,1.7

				c0,0.2,0,0.3-0.2,0.4L13.6,39.8z M34,16.6l-4.9,3.1l-0.4-1.2l5.2-3.1l0.3,0.6C34.4,16.1,34.3,16.4,34,16.6"/>

			<path id="Path_1133" class="st6" d="M39,24.5c0.6,1.3,1,2.7,1.1,4.1c0,0.2,0,0.5-0.1,0.7c0.3-0.1,0.5-0.1,0.8-0.1

				c2.7,0,2.7,2.8,5.4,2.8c1.6,0,2.3-1,3.2-1.9l5.9-13.6c1.1-2.5,0-5.4-2.5-6.4c0,0,0,0,0,0L51,9.3c-2.5-1.1-5.4,0-6.4,2.5

				c0,0,0,0,0,0l-0.6,1.5l-1.2,2.8L39,24.5z"/>

			<path id="Path_1134" class="st7" d="M39,24.5c0.6,1.3,1,2.7,1.1,4.1c0,0.2,0,0.5-0.1,0.7c0.3-0.1,0.5-0.1,0.8-0.1h0

				c-0.1-0.4-0.3-0.9-0.5-1.3l3.6-8.3l1.2-2.8l0.6-1.5c1.1-2.5,4-3.6,6.4-2.5c0,0,0,0,0,0l1.9,0.8c0.6,0.3,1.2,0.7,1.6,1.2

				c0.1-2-1.1-3.8-2.9-4.6L51,9.3c-2.5-1.1-5.4,0-6.4,2.5c0,0,0,0,0,0l-0.6,1.5l-1.2,2.8L39,24.5z"/>

			<path id="Path_1135" class="st8" d="M21.6,21.8c1-1,2.6-1,3.5,0l1.1,1.1L25.2,24c-1,1-2.6,1-3.5,0l-1.1-1.1L21.6,21.8z"/>

			<path id="Path_1136" class="st9" d="M35.4,32c2.4,0,2.7-2.2,4.6-2.7c0-0.2,0.1-0.5,0.1-0.7c0-2.6-2.1-7.5-4.7-7.5

				s-4.7,4.9-4.7,7.5c0,0.2,0,0.5,0.1,0.7C32.7,29.8,33,32,35.4,32"/>

			<path id="Path_1137" class="st10" d="M35.4,21.1c-2.6,0-4.7,4.9-4.7,7.5c0,0.2,0,0.5,0.1,0.7c0.8,0.2,1.5,0.7,2,1.4v-0.2

				c0-2.6,2.1-7.5,4.7-7.5c0.3,0,0.6,0.1,0.9,0.2C37.5,22,36.5,21.1,35.4,21.1"/>

			<path id="Path_1138" class="st11" d="M21.8,24.1c-1.1,1.1-1.7,2.6-1.6,4.1c0,0.4,0,0.8,0.1,1.1c0,0,0,0,0,0

				c1.6,0.7,2,2.6,4.2,2.6c2.7,0,2.7-2.8,5.4-2.8c0.3,0,0.5,0,0.8,0.1c0-0.2-0.1-0.5-0.1-0.7c0-1.1,0.3-2.2,0.7-3.2

				c-1-1.9-3.1-3.1-5.2-3.1c-0.1,0-0.3,0-0.4,0l0.6,0.6L25.2,24C24.3,24.9,22.8,25,21.8,24.1"/>

			<path id="Path_1139" class="st12" d="M21.8,24.1c-1.1,1.1-1.7,2.6-1.6,4.1c0,0.4,0,0.8,0.1,1.1c0,0,0,0,0,0

				c1.6,0.7,2,2.6,4.2,2.6c0.6,0,1.2-0.2,1.7-0.5c-0.6-0.5-1.2-1-1.8-1.5c-0.5-0.4-0.8-1.1-0.8-1.8v0c0-1.5,0.6-3,1.6-4.1L25.2,24

				C24.2,24.9,22.8,25,21.8,24.1"/>

			<path id="Path_1140" class="st9" d="M31.4,25.4L31.4,25.4c0.7-1.9,2-3.8,3.4-4.2c-0.7-2.5-2.4-5.3-4.4-5.3

				c-2.3,0-4.2,3.7-4.6,6.4c0.1,0,0.2,0,0.3,0C28.3,22.3,30.3,23.5,31.4,25.4"/>

			<path id="Path_1141" class="st10" d="M30.4,15.9c-2.3,0-4.2,3.7-4.6,6.4c0.1,0,0.2,0,0.3,0c0.6,0,1.2,0.1,1.8,0.3

				c0.7-2.5,2.4-5.5,4.4-5.5c0.1,0,0.2,0,0.4,0C32.1,16.4,31.3,16,30.4,15.9"/>

			<path id="Path_1142" d="M51,28.6l5.1-11.6c0.6-1.4,0.6-3,0.1-4.4c-1.2-3-3.9-3.4-4.9-4c-2.9-1.3-6.2,0.1-7.5,2.9L43.1,13

				c-0.2,0.4,0,0.9,0.4,1.1s0.9,0,1.1-0.4l0,0c0.5-0.8,0.7-2.8,2.9-3.6c2.2-0.9,3.7,0.5,5,0.9c2.1,0.9,3,3.3,2.1,5.4l-0.8,1.9

				c-1.4-1.1-3.2-1.8-5.1-1.8c-0.4,0-0.8,0.3-0.8,0.8c0,0.4,0.3,0.8,0.8,0.8c1.6,0,3.2,0.7,4.5,1.8L52,22.1

				c-1.4-1.1-3.2-1.8-5.1-1.8c-0.4,0-0.8,0.3-0.8,0.8c0,0.4,0.3,0.8,0.8,0.8c1.6,0,3.2,0.7,4.5,1.8l-1.1,2.4

				c-1.4-1.1-3.2-1.8-5.1-1.8c-0.4,0-0.8,0.3-0.8,0.8c0,0.4,0.3,0.8,0.8,0.8c1.6,0,3.2,0.7,4.5,1.8l-0.9,2c-0.8,0.8-1.3,1.5-2.5,1.5

				c-2.2,0-2.4-2.8-5.4-2.8c-0.1-1.4-0.4-2.7-1-3.9l3.5-8c0.2-0.4,0-0.9-0.4-1.1s-0.9,0-1.1,0.4l-3,6.8c-0.7-1.3-2.1-2.2-3.5-2.4

				c-2.1-6.3-6.9-7.2-9.5-0.8c-0.1-0.2-0.3-0.3-0.4-0.5c-0.3-0.3-0.9-0.3-1.2,0.1c-0.3,0.3-0.3,0.8,0,1.1l0.2,0.2

				c-1.2-0.4-2.6-0.1-3.5,0.8l-1.1,1.1c-0.3,0.3-0.3,0.8,0,1.1c0,0,0,0,0,0l0.7,0.7c-1,1.3-1.4,2.8-1.4,4.4c0,0,0,0.1,0,0.1

				c0.4,0.8,0.9,1.5,1.5,2.2c0.8,0.8,1.6,1.9,3.3,2c3.3,0.2,3.5-2.8,5.7-2.8c0.9,0,1.6,0.5,2.1,1.2c1.3,1.8,3.9,2.2,5.7,0.9

				c0.3-0.2,0.6-0.5,0.9-0.9c1.1-1.2,1.4-1,1.5-1.1c2.7-0.7,2.7,2.8,6,2.8c2,0,2.8-1.2,3.6-2C50.5,30.2,50.9,29.4,51,28.6

				 M23.4,21.9c1,0,1.4,0.7,1.7,1l0,0c-0.5,0.5-0.5,0.5-0.6,0.6c-0.6,0.5-1.5,0.5-2.2,0c-0.1-0.1-0.1-0.1-0.6-0.6

				C22.1,22.3,22.7,21.9,23.4,21.9 M30.4,16.7c1.3,0,2.6,1.9,3.4,4c-1.1,0.7-2,1.8-2.6,3c-1.1-1.2-2.6-2-4.3-2.2l0-0.1

				C27.5,19.1,29.1,16.7,30.4,16.7 M35,22c2.2-0.6,4.3,4.4,4.2,6.7c-0.3,0.1-0.5,0.3-0.7,0.4c-1.2,0.9-1.6,2.1-3.1,2.1

				c-1.8,0-2.1-1.7-3.9-2.5C31.4,26.6,33.1,22.5,35,22 M24.5,31.2c-1.6,0-2.1-1.5-3.5-2.3c-0.1-1.3,0.2-2.6,1-3.7

				c1.1,0.5,2.5,0.4,3.5-0.4c0.2,0.4,0.7,0.5,1.1,0.2c0.2-0.1,0.3-0.3,0.3-0.4c0.1-0.5,0.2-1,0.2-1.4c1.4,0.3,2.6,1.1,3.4,2.3

				c-0.3,0.9-0.5,1.9-0.6,2.9C26.8,28.4,26.7,31.2,24.5,31.2"/>

			<path id="Path_1143" class="st13" d="M37.1,47.8l-1.1,8c-0.1,0.7,0.4,1.3,1,1.4c0.1,0,0.2,0,0.2,0c0.6,0,1.1-0.5,1.2-1.1l1.1-8

				c0.1-0.7-0.4-1.3-1.1-1.4c-0.1,0-0.1,0-0.2,0C37.8,46.7,37.2,47.2,37.1,47.8"/>

			<path id="Path_1144" class="st13" d="M17.3,46.5c-0.1,0-0.1,0-0.2,0h0c-0.7,0.1-1.1,0.7-1.1,1.3c0,0,0,0,0,0l1,8v0

				c0.1,0.6,0.6,1.1,1.2,1.1c0.1,0,0.1,0,0.1,0h0c0.3,0,0.6-0.2,0.8-0.5c0.2-0.3,0.3-0.6,0.2-0.9l-1-8v0

				C18.4,47,17.9,46.5,17.3,46.5"/>

			<path id="Path_1145" class="st13" d="M27.3,56.9c0.7,0,1.2-0.6,1.2-1.2v-8c0-0.7-0.6-1.2-1.2-1.2s-1.2,0.6-1.2,1.2v8

				C26.1,56.4,26.6,56.9,27.3,56.9"/>

			<path id="Path_1146" d="M48.6,30.1H6.1c-2.9,0-5.3,2.4-5.3,5.3c0,1.2,0.4,2.3,1.1,3.2c0.7,0.9,1.6,1.6,2.7,1.9

				c0.4,0.1,0.8,0.5,0.8,1l2.1,17c0.5,3.7,3.6,6.6,7.4,6.6h24.6c3.7,0,6.9-2.7,7.4-6.4c0.1-0.5-0.3-1.1-0.8-1.1c0,0-0.1,0-0.1,0

				c-0.5,0-0.9,0.4-1,0.9c-0.4,2.7-2.7,4.7-5.4,4.7H14.9c-2.8,0-5.1-2.1-5.4-4.8l-2-16.2c-0.1-0.6,0.4-1.2,1-1.3c0,0,0.1,0,0.1,0H46

				c0.6,0,1.2,0.5,1.2,1.2c0,0.1,0,0.1,0,0.2l-0.8,5.4c-0.1,0.5,0.3,1.1,0.8,1.1c0,0,0.1,0,0.1,0c0.5,0,0.9-0.4,1-0.9l0.9-6.3

				c0.1-0.4,0.4-0.8,0.8-1c1.1-0.3,2-1,2.7-1.9c1.8-2.3,1.3-5.7-1-7.5C50.9,30.5,49.8,30.1,48.6,30.1"/>

			<path id="Path_1147" class="st14" d="M48.6,38.7H6.1c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3c0,0,0,0,0,0h42.5

				c1.8,0,3.3,1.5,3.3,3.3S50.4,38.8,48.6,38.7"/>

		</g>

	</g>

</g>

</svg>`;

export const defaultProductSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="72.429" height="72.429" viewBox="0 0 72.429 72.429">
  <g id="image" transform="translate(-2 -2)" opacity="0.5">
  <path id="Path_936" data-name="Path 936" d="M4.587,55.718a2.444,2.444,0,0,0,2.587-2.587V12.26A2.444,2.444,0,0,1,9.76,9.674H50.631a2.444,2.444,0,0,0,2.587-2.587A2.444,2.444,0,0,0,50.631,4.5H9.76A7.622,7.622,0,0,0,2,12.26V53.131A2.444,2.444,0,0,0,4.587,55.718Z" transform="translate(0 3.967)" fill="var(--primary-color)"/>
  <path id="Path_937" data-name="Path 937" d="M74.429,16.227A7.719,7.719,0,0,0,70.549,9.5l3.1-3.1a2.5,2.5,0,0,0,0-3.621,2.5,2.5,0,0,0-3.621,0L2.776,70.032a2.5,2.5,0,0,0,0,3.621,2.348,2.348,0,0,0,1.811.776A2.348,2.348,0,0,0,6.4,73.653l5.691-5.691H66.669a7.622,7.622,0,0,0,7.76-7.76ZM69.256,60.2a2.444,2.444,0,0,1-2.587,2.587H17.262L36.145,43.905l6.726,9.312a3.193,3.193,0,0,0,2.069,1.035,2.937,2.937,0,0,0,2.069-.776l8.019-8.795,7.76,10.606a2.353,2.353,0,0,0,2.069,1.035A3.677,3.677,0,0,0,66.41,55.8a2.736,2.736,0,0,0,.517-3.621L57.357,38.991a3.193,3.193,0,0,0-2.069-1.035,2.937,2.937,0,0,0-2.069.776l-7.76,8.795-5.174-7.5L47.01,33.3a8.2,8.2,0,0,0,5.95,2.328,8.335,8.335,0,0,0,8.278-8.278,9.42,9.42,0,0,0-2.328-5.95l7.76-7.76h0a2.444,2.444,0,0,1,2.587,2.587ZM55.028,25.022a3.279,3.279,0,0,1,1.035,2.328,3.114,3.114,0,0,1-5.432,2.069Z" transform="translate(0 0)" fill="var(--primary-color)"/>
  <path id="Path_938" data-name="Path 938" d="M19.093,11.4a3.193,3.193,0,0,0-2.069,1.035L8.487,25.11a2.711,2.711,0,0,0,.259,3.363L9,28.731a3.677,3.677,0,0,0,1.552.517,3.193,3.193,0,0,0,2.069-1.035l6.467-9.83a2.354,2.354,0,0,0,3.1,0,2.32,2.32,0,0,0,.517-3.621l-.259-.259L20.9,12.435C20.9,11.659,19.869,11.4,19.093,11.4Z" transform="translate(9.55 14.915)"/>
  </g>
  </svg>`;

export const locationSvg = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="26.4" height="26.4" viewBox="0 0 36.4 36.4">
  <defs>
    <clipPath id="clip-path">
      <rect id="Rectangle_358" data-name="Rectangle 358" width="36.4" height="36.4" fill="var(--primary-color)"/>
    </clipPath>
  </defs>
  <g id="g831" transform="translate(113.733 796.531)">
    <g id="g833" transform="translate(-113.733 -796.531)">
      <g id="Group_592" data-name="Group 592" transform="translate(0 0)">
        <g id="g835" clip-path="url(#clip-path)">
          <g id="g841" transform="translate(8.601 4.554)">
            <g id="path843" transform="translate(0 0)">
              <path id="Path_918" data-name="Path 918" d="M-59.6-344.406a3.22,3.22,0,0,1-2.559-1.28l-5.124-6.83a9.506,9.506,0,0,1-1.914-5.753,9.534,9.534,0,0,1,2.81-6.787,9.534,9.534,0,0,1,6.787-2.81,9.534,9.534,0,0,1,6.787,2.81,9.534,9.534,0,0,1,2.81,6.787,9.506,9.506,0,0,1-1.914,5.753l-5.124,6.83A3.22,3.22,0,0,1-59.6-344.406ZM-65.58-353.8l5.124,6.83a1.058,1.058,0,0,0,.853.427,1.058,1.058,0,0,0,.853-.427l5.124-6.83a7.4,7.4,0,0,0,1.488-4.473,7.473,7.473,0,0,0-7.464-7.464,7.473,7.473,0,0,0-7.464,7.464A7.4,7.4,0,0,0-65.58-353.8Z" transform="translate(69.2 367.866)" fill="var(--primary-color)"/>
            </g>
          </g>
          <g id="g845" transform="translate(14.998 10.951)">
            <g id="path847" transform="translate(0 0)">
              <path id="Path_919" data-name="Path 919" d="M-130.134-73.6a3.2,3.2,0,0,1-3.2-3.2,3.2,3.2,0,0,1,3.2-3.2,3.2,3.2,0,0,1,3.2,3.2A3.2,3.2,0,0,1-130.134-73.6Zm0-4.265A1.069,1.069,0,0,0-131.2-76.8a1.069,1.069,0,0,0,1.066,1.066,1.069,1.069,0,0,0,1.066-1.066A1.069,1.069,0,0,0-130.134-77.867Z" transform="translate(133.333 80)" fill="var(--primary-color)"/>
            </g>
          </g>
          <g id="g849" transform="translate(12.866 29.719)">
            <g id="path851">
              <path id="Path_920" data-name="Path 920" d="M-17.069-24.534H-25.6A1.069,1.069,0,0,1-26.667-25.6,1.069,1.069,0,0,1-25.6-26.667h8.531A1.069,1.069,0,0,1-16-25.6,1.069,1.069,0,0,1-17.069-24.534Z" transform="translate(26.667 26.667)" fill="var(--primary-color)"/>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>
`;
